import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DefinitionPage1.css';

const DefinitionPage = () => {
  const navigate = useNavigate();

  return (
    <div className="definition-overlay">
      <div className="definition-box">
        <button className="close-button" onClick={() => navigate(-1)}>×</button>
        <h2>Key Definitions - View Summary in Tables</h2>


        <p className="definition-note">
          <strong>Note:</strong> The "Last data updated" date and time on the dashboard shows when the data was last refreshed. All information is based on data available up to that point.
        </p>

        <table className="definition-table">
          <tbody>
            <tr>
              <th>PID</th>
              <td>Choose the project ID you want to view data for.</td>
            </tr>
            <tr>
              <th>Organization Name</th>
              <td>Choose the Organization name (State), which corresponds to the state associated with the selected PID.</td>
            </tr>
            <tr>
              <th>Manager Name</th>
              <td>Select the manager's name to view data specific to that person.</td>
            </tr>
            <tr>
              <th>Day Wise Data</th>
              <td>
                This table shows you employee-wise, Org-wise detailed daily breakdown of cases for DI, DFL, and YC. By default, it displays the count of BR cases. You can switch to "Open" and "DS" case statuses using the tabs.
              </td>
            </tr>
            <tr>
              <th>Weekly Data</th>
              <td>
                This table shows you employee-wise, Org-wise detailed weekly breakdown of cases for DI, DFL, and YC. By default, it displays the count of BR cases. You can switch to "Open" and "DS" case statuses using the tabs.
              </td>
            </tr>
            <tr>
              <th>Monthly Data</th>
              <td>
                This table shows you employee-wise, Org-wise detailed monthly breakdown of cases for DI, DFL, and YC. By default, it displays the count of BR cases. You can switch to "Open" and "DS" case statuses using the tabs.
              </td>
            </tr>
            <tr>
              <th>Export Data</th>
              <td>
                With this button, you can export the data from the table into an Excel file. If you've applied any filters, only the filtered data that you see in the table will be downloaded.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DefinitionPage;
